import constants from "../constants";
import { get, getQueryString } from "../utils";

export const getPermissions = ({ userEmail }: { userEmail: string }) => {
  const queryString = getQueryString({
    userEmail: encodeURIComponent(userEmail),
    appId: constants.appId
  });

  const URL = constants.IAM_BASE_URL + `v1/iam/userpermissions?${queryString}`;
  return get(URL, true, true, false);
};

export const requestToken = ({ storeId }: { storeId: string }) => {
  const URL =
    constants.IAM_BASE_URL + `v1/iam/firebase/token?storeId=${storeId}`;
  return get(URL, true, true);
};
